import React, { ReactNode } from 'react'

interface LinkProps {
    href?: string
    children: ReactNode
    className?: string
    onClick?: () => void
}

export const Link: React.FC<LinkProps> = ({ href, children, className, onClick }) => {
    return (
        <a href={href} className={`hover:text-primary-blue ${className}`} onClick={onClick}>
            {children}
        </a>
    )
}
